import { useState } from 'react';
import $ from 'jquery';
import { CFS, MD5 } from '../../utils/common';
import Config from '../../utils/config';
import Label from '../../utils/label';

export default function useLogin(popupDiv) {
    const username = localStorage.getItem('username');
    const rememberMe = Boolean(username);
    const [loginData, setLoginData] = useState({
        username: username ? username: '',
        password: '',
        validation: '',
        imageHash: Date.now(),
        rememberMe: rememberMe
    });
    const [errorMessage, setErrorMessage] = useState({
        username: '',
        password: '',
        validation: ''
    });
    const [viewData, setViewData] = useState({
        logining: false,
        refreshingLoginCode: true
    });

    function refreshImageHash() {
        setLoginData(state => ({ ...state, imageHash: Date.now(), validation: '' }));
        setRefreshingLoginCode(true);
    }

    function setRefreshingLoginCode(status) {
        setViewData(state => ({ ...state, refreshingLoginCode: status }));
    }

    function initErrorMessage() {
        setErrorMessage({
            username: '',
            password: '',
            validation: ''
        });
    }

    function checkData() {
        if (!loginData.username) {
            throw { username: Label.errlogin_enter_un };
        }

        if (!loginData.password) {
            throw { password: Label.errlogin_enter_pw };
        }

        if (!loginData.validation) {
            throw { validation: Label.errlogin_enter_valid };
        }
    }

    async function submit() {
        return await Promise.resolve($.post('DepositProcessLogin', {
            txtUserName: loginData.username,
            txtPasswd: MD5(CFS(loginData.password) + loginData.validation),
            txtValidCode: loginData.validation
        }));
    }

    function handleResponse(response) {
        const success = response.ErrorCode === '0' || response.ErrorCode === 0 || response.ErrorCode === '';
        if (success) {
            location.href = response.url;
            return;
        }

        const errorMsg = `${response.ErrorCode}: ${response.ShowErrorMsg}`;

        switch (response.ErrorCode) {
            case 'SP-1005':
            case 'SP-1006':
                throw { validation: errorMsg };
            default:
                throw {
                    username: errorMsg,
                    password: ' '// if errorMessage.password === ' ' show error frame, but not show error message
                };
        }
    }

    function onChange(event) {
        const id = event.target.id;
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        setLoginData(state => ({
            ...state,
            [id]: value
        }));
        if (errorMessage[id]) {
            initErrorMessage();
        }
    }

    function setUsername() {
        if (loginData.rememberMe) {
            localStorage.setItem('username', loginData.username);
        } else {
            localStorage.removeItem('username');
        }
    }

    async function onLogin() {
        try {
            if (viewData.logining) {
                return await Promise.resolve({ message: 'logining...' });
            }

            setViewData(state => ({ ...state, logining: true }));
            initErrorMessage();
            checkData();
            handleResponse(await submit());
        } catch (errors) {
            setErrorMessage(state => ({ ...state, ...errors }));
            refreshImageHash();
        } finally {
            setViewData(state => ({ ...state, logining: false }));
            setUsername();
        }
    }

    function onSignUp() {
        popupDiv(0);
        if (Config.appConfig.SiteID !== '4215600') {
            return;
        }

        try {
            window.ga('send', 'event', 'Home', 'Button_Click', 'Signup_Button');
        } catch (error) {
            console.error(error);
        }
    }

    function onValidationKeyDown(event) {
        if (event.keyCode === 13) {
			onLogin();
		}
    }

    return {
        loginData,
        errorMessage,
        onLogin,
        onChange,
        refreshImageHash,
        viewData,
        setRefreshingLoginCode,
        onSignUp,
        onValidationKeyDown,
        initErrorMessage
    };
}